import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ArrowLeft, FileText, Shield, Mail } from "lucide-react";

/**
 * Legal hub. Three short sections — Terms, Privacy, Contact. We deliberately
 * keep these in-app instead of linking out so the user never bounces out of
 * the PWA install.
 */
export default function Legal() {
  const { t } = useTranslation();
  const nav = useNavigate();

  return (
    <div className="min-h-screen bg-white text-[#0A0B0D] max-w-2xl mx-auto pb-32" data-testid="legal-page">
      <div className="sticky top-0 z-30 bg-white border-b border-[#E2DFD4]">
        <div className="flex items-center gap-2 px-5 py-5">
          <button onClick={() => nav(-1)} className="w-10 h-10 -ml-2 flex items-center justify-center rounded-full hover:bg-[#F4F1E8]" data-testid="legal-back" aria-label="Back">
            <ArrowLeft className="w-7 h-7" strokeWidth={3} />
          </button>
          <h1 className="font-display font-black text-[28px] tracking-tight">{t("settings.legal")}</h1>
        </div>
      </div>

      <div className="px-5 pt-6 space-y-6 text-sm leading-relaxed text-[#3D424B]">
        <section>
          <h2 className="font-display font-black text-lg flex items-center gap-2 mb-2 text-[#0A0B0D]">
            <FileText className="w-5 h-5" strokeWidth={2.5} /> {t("legal.termsTitle")}
          </h2>
          <p>{t("legal.termsBody")}</p>
        </section>

        <section>
          <h2 className="font-display font-black text-lg flex items-center gap-2 mb-2 text-[#0A0B0D]">
            <Shield className="w-5 h-5" strokeWidth={2.5} /> {t("legal.privacyTitle")}
          </h2>
          <p>{t("legal.privacyBody")}</p>
        </section>

        <section>
          <h2 className="font-display font-black text-lg flex items-center gap-2 mb-2 text-[#0A0B0D]">
            <Mail className="w-5 h-5" strokeWidth={2.5} /> {t("legal.contactTitle")}
          </h2>
          <p>
            {t("legal.contactBody")}{" "}
            <a href="mailto:support@tanta.app" className="text-[#00CED1] font-semibold hover:underline">support@tanta.app</a>
          </p>
        </section>
      </div>
    </div>
  );
}
